import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BillingCardEligibleEntitiesQueryCgResponse,
  BillingCardEligibleEntitiesQueryVariables,
} from '@common/graphql/schema';

const STAFFING_REQUEST_FIELDS_FRAGMENT = gql`
  fragment StaffingRequestFields on StaffingRequest {
    code
    organizationUnit {
      id
      name
      costCenter
      clinicalUnit {
        id
        displayName
      }
    }
    organizationBusiness {
      id
      name
    }
  }
`;

type BillingCardEligibleEntitiesType =
  BillingCardEligibleEntitiesQueryCgResponse['billingCardEligibleEntities'];

export type BillingCardExtensionOfferType =
  NonNullable<BillingCardEligibleEntitiesType>['extensionOffers'][number];

export type BillingCardPendingOfferType =
  NonNullable<BillingCardEligibleEntitiesType>['pendingOffers'][number];

export type BillingCardPendingStaffingRequestType =
  NonNullable<BillingCardEligibleEntitiesType>['pendingStaffingRequests'][number];

export type BillingCardOpenStaffingRequestType =
  NonNullable<BillingCardEligibleEntitiesType>['openStaffingRequests'][number];

export const BILLING_CARD_ELEGIBLE_ENTITIES_QUERY: TypedDocumentNode<
  BillingCardEligibleEntitiesQueryCgResponse,
  BillingCardEligibleEntitiesQueryVariables
> = gql`
  query BillingCardEligibleEntities(
    $organizationUnitIds: [ID!]!
    $roleId: ID!
    $roleLevel: RoleLevelEnum!
    $effectiveDate: ISO8601Date!
  ) {
    billingCardEligibleEntities(
      organizationUnitIds: $organizationUnitIds
      roleId: $roleId
      roleLevel: $roleLevel
      effectiveDate: $effectiveDate
    ) {
      extensionOffers {
        id
        staffingRequestAssignment {
          id
          employmentType
          organizationUnit {
            id
            name
            costCenter
            clinicalUnit {
              id
              displayName
            }
          }
          organizationBusiness {
            id
            name
          }
          supplier {
            id
            name
          }
          worksProfile {
            id
            fullName
          }
          staffingRequest {
            id
            code
          }
        }
        billingRegularRate
        state
        startDate
        endDate
        shiftType
        highestRate
        lowestRate
      }
      pendingOffers {
        id
        staffingRequest {
          id
          ...StaffingRequestFields
        }
        staffingRequestApplication {
          id
          employmentType
          supplier {
            id
            name
          }
          worksProfile {
            id
            fullName
          }
        }
        billingRegularRate
        state
        startDate
        endDate
        shiftType
        highestRate
        lowestRate
      }
      pendingStaffingRequests {
        id
        ...StaffingRequestFields
        billingRegularRate
        state
        startDate
        shiftType
        highestRate
        lowestRate
      }
      openStaffingRequests {
        id
        ...StaffingRequestFields
        billingRegularRate
        state
        startDate
        shiftType
        highestRate
        lowestRate
        submittedStaffingRequestApplicationsCount
        inReviewStaffingRequestApplicationsCount
      }
    }
  }
  ${STAFFING_REQUEST_FIELDS_FRAGMENT}
`;
